import React from 'react'

const Atharo = () => {
    return(
        <div className="atharo">
            <div className="atharo-logo"></div>
        </div>
    )
}
export default Atharo;